<div mat-dialog-content>
  <div class="container" align="center">
    <h1 mat-dialog-title><strong>Token máquina</strong></h1>
    <p> Caso você já possua token gerado no cadastro desta máquina, por favor<br />
      faça o upload para confirmar se seu cadastro continua ativo. <br />
      Caso não possua clique no botão "Não possui token". </p>

  </div>
  <div class="custom-file">
    <input #inputFile type="file" class="custom-file-input" id="customFile" (change)="onChangeFile($event)" lang="pt">
    <label class="custom-file-label" for="customFile">Selecione o token maquina para este certificado</label>
  </div>
  <br/><br/>
  <div class="row">
    <div class="col-9">
      <!-- DEVERÁ APARECER QUANDO O ARQUIVO ESTIVER COM EXTENÇÃO INVÁLIDA -->
      <img *ngIf="!arquivo.extensaoValida && possuiErro" class="img-fluid" src="assets/icons/exclamation.png"
        width="16px" />

      <!-- DEVERÁ APARECER QUANDO O ARQUIVO ESTIVER COM EXTENÇÃO VÁLIDA -->
      <img *ngIf="arquivo.extensaoValida" class="img-fluid" src="assets/icons/check.png" width="16px" />
      <small>{{arquivo.nome}}</small><br />
      <!-- DEVERÁ APARECER QUANDO O ARQUIVO ESTIVER COM EXTENÇÃO INVÁLIDA -->
      <small *ngIf="!arquivo.extensaoValida && possuiErro" class="text-danger">Extenção de arquivo
        inválida, exclua este arquivo</small>
      <small *ngIf="possuiErro" class="text-danger">{{mensagemErro}}</small>
    </div>
    <div class="col-3" *ngIf="possuiErro">
      <button mat-mini-fab color="warn" (click)="excluirArquivo()" title="Apagar" width="14px" align="right">
        <img class="img-fluid" src="assets/icons/trash_white.png" width="14px" />
      </button>
    </div>
  </div>
</div>
<br/><br/>
<div mat-dialog-actions class="botoes">
  <button mat-raised-button class="md-icon-button btnOK" *ngIf="aparecerBtEnviar()" (click)="onYesClick()"
    cdkFocusInitial>
    <img class="img-fluid" src="assets/icons/save_alt_white.png" width="24px" /> Carregar Token
  </button>
  <button mat-raised-button class="md-icon-button btnNok" (click)="onNoClick()">
    <img class="img-fluid" src="assets/icons/white_close_icon.png" width="16px" />Não possui token
  </button>
</div>